<template>
  <div style="padding: 15px;">
    <div style="margin-bottom:20px">
      <span>用户名：</span>
      <el-select v-model="value" clearable filterable placeholder="请选择">
    <el-option
    style=" font-size: 14px;line-height: 40px;height: 40px;text-align: center;"
      v-for="(item,index) in options"
      :key="index"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
  <div style="width: 80px;height: 35px;display: inline-block;text-align: center;line-height: 35px;background-color: #0f54a9;color: #ffffff;border-radius: 10px;margin-left: 40px;" @click="getdata()">查询</div>
   <div style="width: 80px;height: 35px;display: inline-block;text-align: center;line-height: 35px;background-color: #0f54a9;color: #ffffff;border-radius: 10px;margin-left: 40px;" @click="dialogVisible=true;">新增</div>
    </div>
    <table style="width: 100%; border-collapse: collapse;">
    <tr>
      <th style="border: 1px solid #ebeef5; padding: 10px; text-align: left; background-color: rgb(245, 245, 245);color:#606266;text-align: center;">用户名</th>
      <th style="border: 1px solid #ebeef5; padding: 10px; text-align: left; background-color: rgb(245, 245, 245);color:#606266;text-align: center;">设备-心跳（次/分钟）</th>
      <th style="border: 1px solid #ebeef5; padding: 10px; text-align: left; background-color: rgb(245, 245, 245);color:#606266;text-align: center;">设备-血压（高压/低压，mmHg）</th>
      <th style="border: 1px solid #ebeef5; padding: 10px; text-align: left; background-color: rgb(245, 245, 245);color:#606266;text-align: center;">仪器--心跳（次/分钟）</th>
      <th style="border: 1px solid #ebeef5; padding: 10px; text-align: left; background-color: rgb(245, 245, 245);color:#606266;text-align: center;">仪器-血压（高压/低压）</th>
      <th style="border: 1px solid #ebeef5; padding: 10px; text-align: left; background-color: rgb(245, 245, 245);color:#606266;text-align: center;">监测时间</th>
    </tr>
    <tr v-for="(item,index) in tableData" :key="index">
      <td style="border: 1px solid #ebeef5; padding: 10px; text-align: left;text-align: center;">{{item.userName}}</td>
      <td style="border: 1px solid #ebeef5; padding: 10px; text-align: left;text-align: center;">{{item.watchHr}}</td>
      <td style="border: 1px solid #ebeef5; padding: 10px; text-align: left;text-align: center;">{{item.watchSbp}}/{{item.watchDbp}}</td>
      <td style="border: 1px solid #ebeef5; padding: 10px; text-align: left;text-align: center;">{{item.deviceHr}}</td>
      <td style="border: 1px solid #ebeef5; padding: 10px; text-align: left;text-align: center;">{{item.deviceSbp}}/{{item.deviceDbp}}</td>
      <td style="border: 1px solid #ebeef5; padding: 10px; text-align: left;text-align: center;">{{item.sysTime}}</td>
    </tr>
  </table>

      <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;">用户名：</span>
        <!-- <el-input style="display: inline-block;width:200px" v-model="userName" placeholder="请输入内容"></el-input> -->
        <el-select v-model="userName" filterable placeholder="请选择">
        <el-option
        style=" font-size: 14px;line-height: 40px;height: 40px;text-align: center;"
          v-for="(item,index) in options"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      </div>
      <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">仪器测量的收缩压（高压）：</span>
        <el-input style="display: inline-block;width:150px" v-model="deviceSbp" placeholder="请输入内容"></el-input>
      </div>
      <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">仪器测量的收缩压（低压）：</span>
        <el-input style="display: inline-block;width:150px" v-model="deviceDbp" placeholder="请输入内容"></el-input>
      </div>
      <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">手表测量的收缩压（高压）：</span>
        <el-input style="display: inline-block;width:150px" v-model="watchSbp" placeholder="请输入内容"></el-input>
      </div>
      <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">手表测量的舒张压（低压）：</span>
        <el-input style="display: inline-block;width:150px" v-model="watchDbp" placeholder="请输入内容"></el-input>
      </div>
      <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">仪器测量的心率：</span>
        <el-input style="display: inline-block;width:150px" v-model="deviceHr" placeholder="请输入内容"></el-input>
      </div>
      <!-- <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">仪器测量的血氧饱和度：</span>
        <el-input style="display: inline-block;width:150px" v-model="deviceSpo2" placeholder="请输入内容"></el-input>
      </div> -->
      <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">手表测量的心率：</span>
        <el-input style="display: inline-block;width:150px" v-model="watchHr" placeholder="请输入内容"></el-input>
      </div>
    
      <!-- <div>
        <span  style="display: inline-block;width:190px;font-size: 14px;text-align:right;margin-top:20px">手表测量的血氧饱和度：</span>
        <el-input style="display: inline-block;width:150px" v-model="watchSpo2" placeholder="请输入内容"></el-input>
      </div> -->
      <!-- <div>
        <span  style="display: inline-block;width:250px;text-align:right;margin-top:20px">开始预警时间：</span>
        <el-date-picker
          v-model="value1"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
        <input style="width: 31vh;font-size: 1.8vh;padding-right: 0px !important;border-radius: 1vh!important;border: 0.1vh solid #DCDFE6;padding-left: 2vh;" type="datetime" v-model="createTime" id="birthday" name="birthday">
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;sure()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { rulesName,mearecordlist,savemearecord  } from '@/api/activity'
export default {
  data() {
    return {
      createTime:null,
      watchSpo2:'',
      watchDbp:'',
      watchSbp:"",
      watchHr:'',
      deviceSpo2:'',
      deviceHr:'',
      userName:"",
      deviceSbp:'',
      deviceDbp:'',
      dialogVisible: false,
      options: [],
        value: '',
       tableData: []
    };
  },
  components: {
  },
  computed: {},
  mounted() {
    document.title = "测量记录"; 
    this.getdata()
  },
  beforeCreate() {},
  methods: {
    getdata() {
      rulesName().then((res)=> {
      this.options = JSON.parse(res.data.ruleJson) 
      console.log(res.data.ruleJson)
    })
    var obj = {
        pn: 1,
        ps: 500,
        userName: this.value
    }
    mearecordlist(obj).then((res) =>{
      this.tableData = res.data
      console.log(res)
    })
    },
    sure() {
      var obj = {
        createTime:this.createTime,
        watchSpo2:this.watchSpo2,
        watchDbp:this.watchDbp,
        watchSbp:this.watchSbp,
        watchHr:this.watchHr,
        deviceSpo2:this.deviceSpo2,
        deviceHr:this.deviceHr,
        userName:this.userName,
        deviceSbp:this.deviceSbp,
        deviceDbp:this.deviceDbp,
      }
      savemearecord(obj).then((res)=>{
        if(res.code == '1000') {
          this.watchSpo2 = '';
          this.watchDbp = '';
          this.watchSbp = "";
          this.watchHr = '';
          this.deviceSpo2 = '';
          this.deviceHr = '';
          this.userName = "";
          this.deviceSbp = '';
          this.deviceDbp = '';
          alert('添加成功')
          this.getdata()
        }
       
        console.log(res)
      })
      console.log(obj) 
    }
  },
};
</script>
<style scoped>
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";

}
/deep/ .el-message__content  {
  font-size: 2vh !important;
}
/deep/ .el-input__inner {
  width: 15vh;
  height: 4vh;
  line-height: 4vh;
  font-size: 1.8vh;
  padding-right: 0px !important;
  border-radius: 1vh!important;
  border: 0.1vh solid #DCDFE6;
  padding-left: 2vh;
}
/deep/ .el-input {
  font-size: 1vh;
}
/deep/ .el-select .el-input .el-select__caret.is-reverse {
  width: 1vh;
  font-size: 2vh !important;
  height: 3vh !important;
  line-height: 3vh !important;
  position: absolute;
  top: 0px;
  right: 0px;
  display: none;
}
/deep/ .el-select .el-input .el-select__caret {
  display: none;
}
/deep/ .el-dialog__header {
  padding:2vh !important;
}
/deep/ .el-dialog__title {
  line-height: 5vh;
  font-size: 2vh;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 2vh !important;
  font-size: 2vh;
}
/deep/ .el-button {
  font-size: 2vh;
  border: 0.1vh solid #dcdfe6;
  width: 10vh;
  line-height: 3vh;
}
/deep/ .el-button--primary {
  background-color: rgb(15, 84, 169) !important;
  border: 0.1vh solid rgb(15, 84, 169) !important;
}
/deep/ .el-dialog__footer {
  padding: 6vh;
}
/deep/ .el-input__icon:after {
  display: none;
}
/deep/ .el-icon-date:before {
  display: none;
}
/deep/ .el-select-dropdown__empty {
  font-size: 2vh;
}

</style>


// WEBPACK FOOTER //
// src/views/recordList/index.vue